// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1uEAH","image":"Header_image__1039O","name":"Header_name__3q2WO","info":"Header_info__aX9xu","infoRow":"Header_infoRow__2iZ6F"};